module.exports = __webpack_public_path__ + "static/media/Glauco Lima Soundtrack Portfolio.7e42a918.jpg";